export default __webpack_public_path__ + "static/media/Arrow_RightWhite.76d15b0b.svg";